import {
  Row,
  Col,
  Button,
  Form,
  Table,
  Modal,
  InputGroup,
} from "react-bootstrap";
import SignupClientForm from "../../../../components/SignupClientForm";
import UpdateClientForm from "../../../../components/UpdateClientForm";
import { useState } from "react";
import PaginationComponent from "../../../../components/Pagination";
import {
  getAllUsers,
  searchUser,
  deleteUser,
  AddUser,
} from "../../../../services/api";
import { IoIosAddCircle } from "react-icons/io";
import { MdDelete, MdEdit } from "react-icons/md";
import { useEffect } from "react";
import LoadingIndicator from "../../../../components/LoadingIndicator";
import useNotification from "../../../../contexts/notification";

export default function ClientsTab() {
  const [query, setQuery] = useState("");
  const [data, setData] = useState(null);
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showUpdateClientModal, setShowUpdateClientModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const { setMessage } = useNotification();

  const refresh = () => {
    const error = {
      error: true,
      content: "Erro ao recarregar. Tente novamente mais tarde",
    };

    if (query) {
      searchUser(query, page).then(
        (data) => {
          setData(data);
        },
        () => setMessage(error)
      );
    } else {
      getAllUsers(page).then(
        (data) => {
          setData(data);
        },
        () => setMessage(error)
      );
    }
  };

  function handleQueryClient(e) {
    e.preventDefault();
    searchUser(query, page).then((data) => {
      setData(data);
    });
  }

  useEffect(() => {
    if (query.length === 0) {
      getAllUsers(page).then(
        (data) => {
          setData(data);
          setLoading(false);
        },
        () =>
          setMessage({
            error: true,
            content: "Um erro ocorreu. Tente novamente mais tarde",
          })
      );
    }
  }, [query, page, setMessage]);

  useEffect(() => {
    if (selectedClient) {
      setShowUpdateClientModal(true);
    }
  }, [selectedClient]);

  function AddClientModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Adicionar Cliente
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SignupClientForm
            onSubmit={async (data) => {
              console.log(data);
              try {
                
                await AddUser(data);
                setShowAddClientModal(false);
                refresh();
                setMessage({
                  error: false,
                  content: "Cliente Cadastrado com sucesso.",
                });
              } catch (err) {
                setMessage({
                  error: true,
                  content: "Um erro ocorreu. Tente novamente mais tarde",
                });
              }
            }}
          />
        </Modal.Body>
      </Modal>
    );
  }

  function UpdateClientModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Atualizar Cliente
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UpdateClientForm
            clientId={selectedClient}
            onDone={props.onHide}
           
          />
        </Modal.Body>
      </Modal>
    );
  }

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Row className="d-flex justify-content-between align-items-center">
        <Col xs={12} md={9} lg={10}>
          <Form>
            <Form.Group className="my-3 d-flex" controlId="">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Buscar consumidor"
                  required
                  value={query}
                  onKeyUp={handleQueryClient}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
          </Form>
        </Col>

        <Col xs={12} md={3} lg={2}>
          <div>
            <div>
              <Button
                onClick={() => setShowAddClientModal(true)}
                className="btn btn-primary d-flex align-items-center text-white"
              >
                <span className="mr-2">ADICIONAR</span>
                <IoIosAddCircle style={{ fontSize: "1.6em" }} />
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Table striped bordered responsive size="sm">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Localidade</th>
                <th>Telefone</th>
                <th>Ações</th>
              </tr>
            </thead>
            {data.data.length === 0 && (
              <h5 className="text-muted text-center my-5">Sem resultados</h5>
            )}
            <tbody>
              {data.data.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>
                    {user.city?.uf??''}, {user.city?.name??''}
                  </td>
                  <td>{user.telephone}</td>
                  <td>
                    <div className="d-flex">
                      <Button
                        className="btn-warning text-white d-flex align-items-center mr-2"
                        size="sm"
                        title="Atualizar"
                        onClick={() => {
                          setSelectedClient(user.id);
                        }}
                      >
                        <MdEdit
                          style={{
                            fontSize: "1.4em",
                          }}
                        />
                      </Button>
                      <Button
                        onClick={() => {
                          let conf = window.confirm("Tem certeza que deseja deletar este item?");
                          if(conf) {
                            deleteUser(user).then(
                              () => setMessage({
                                error: false,
                                content: "Consumidor deletado com sucesso.",
                              }), () => setMessage({
                                error: true,
                                content: "Ocorreu um erro, tente novamente mais tarde."
                              })
                            )
                            refresh()
                          }
                        }}
                        // onClick={() =>
                        //   (window.confirm(
                        //     "Tem certeza que deseja deletar este item?"
                        //   ) &&
                        //     deleteUser(user) &&
                        //     setMessage({
                        //       error: false,
                        //       content: "Consumidor deletado com sucesso",
                        //     })) ||
                        //   refresh()
                        // }
                        size="sm"
                        title="Remover"
                        className="btn btn-danger text-white d-flex align-items-center"
                      >
                        <MdDelete
                          style={{
                            fontSize: "1.4em",
                          }}
                        />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
      <div className="d-flex justify-content-end">
        {data.links && (
          <PaginationComponent pagination={data} onClickPage={setPage} />
        )}
      </div>
      <AddClientModal
        show={showAddClientModal}
        onHide={() => {
          setShowAddClientModal(false);
          refresh();
        }}
      />
      <UpdateClientModal
        show={showUpdateClientModal}
        onHide={() => {
          setShowUpdateClientModal(false);
          setSelectedClient(null);
          refresh();
        }}
      />
    </>
  );
}
